export const getRowLength = (dataNum: number, idx: number) => {
  if (dataNum <= 3) return dataNum;
  else if (dataNum > 3 && dataNum < 6) {
    return idx < 3 ? 3 : dataNum - 3;
  } else if (dataNum === 6) return dataNum / 2;
  else return 0;
};

export const formatDuration = (date: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
  };

  let startDate: Date;
  let endDate: Date;

  if (date.includes("-")) {
    // Range case: "March 2018 – March 2019"
    const [start, end] = date.split("-").map((s) => s.trim());

    // Parse start
    const [startMonth, startYear] = start.split(" ");
    const startMonthIndex = new Date(
      `${startMonth} 1, ${startYear}`
    ).getMonth();
    startDate = new Date(Number(startYear), startMonthIndex, 1);

    // Parse end
    if (end.toLowerCase() === "present") {
      endDate = new Date();
    } else {
      const [endMonth, endYear] = end.split(" ");
      const endMonthIndex = new Date(`${endMonth} 1, ${endYear}`).getMonth();
      endDate = new Date(Number(endYear), endMonthIndex, 1);
    }
  } else {
    // Single date case: "February 2022"
    const [monthName, year] = date.split(" ");
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth();
    startDate = new Date(Number(year), monthIndex, 1);
    endDate = new Date();
  }

  // Format start & end
  const startStr = startDate.toLocaleDateString("en-US", options);
  const endStr =
    date.includes("-") && date.split("-")[1].trim().toLowerCase() === "present"
      ? "Present"
      : endDate.toLocaleDateString("en-US", options);

  // Calculate diff in months
  let months =
    (endDate.getFullYear() - startDate.getFullYear()) * 12 +
    (endDate.getMonth() - startDate.getMonth());

  const years = Math.floor(months / 12);
  months = months % 12;

  // Duration string
  const parts: string[] = [];
  if (years > 0) parts.push(`${years}yr${years > 1 ? "s" : ""}`);
  if (months > 0) parts.push(`${months}mo${months > 1 ? "s" : ""}`);

  const duration = parts.join(" ") || "0mos";
  return `${startStr} - ${endStr} | ${duration}`;
};
